/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */

/**
 * Class for the items inside the notification box
 *
 * @export
 * @class NotificationsItem
 * @extends {React.Component<any, any>}
 */
export default class NotificationsItem extends React.Component<any, any> {

    /**
     * Creates an instance of NotificationsItem.
     * @param {*} props
     * @memberof NotificationsItem
     */
    constructor(props: any) {
        super(props)
        this.state = {

        }
    }

    handleCLick = (data) => {
        switch (data.state) {
            case 'policy':
            case 'renewal':
                window.location.href = window.location.origin + `/clients/policies/view/${data.id}`
                break
            case 'mta':
                window.location.href = window.location.origin +
                    `/clients/policies/mta/${data.id}/summary/${data.summaryId}`
                break
            case 'quote':
                window.location.href = window.location.origin + `/clients/quotes/view/${data.id}`
                break
            default:
                break
        }
    }

    render() {
        return (
            <div>
                <div
                    className="notifications__box__item"
                    onClick={() => this.handleCLick(this.props)}
                >
                    <div
                        className={
                            'notifications__box__item__content notifications__box__item__content--' + this.props.type
                        }
                    >
                        <div className={'title title--' + this.props.type}>
                            {this.props.title}
                        </div>
                        <div className="text">
                            {this.props.children}
                        </div>
                        <div className="time">
                            {
                                (!isNaN(this.props.time) && this.props.time !== null && this.props.time !== '') ?
                                    this.props.time + ' days' :
                                    ''
                            }
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Notifications/components/NotificationItem.tsx